export default __webpack_public_path__ + "static/media/storageUnit1-afterB-1024w.15ae57b0.png";